export default __webpack_public_path__ + "static/media/enoperacion.81d1db0c.svg";